import {Theme} from "@emotion/react";

export const getBreakpoints = (grid: Theme["grid"]) => Object.values(grid).map((breakpoint) => `@media (min-width: ${breakpoint.value}px)`);
